module.exports = __webpack_public_path__ + "static/media/Iran_AP.2ee74376.png";